// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { containerStyles } from "@sc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationPageContainer";
import { color, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

containerStyles.wrapper = {
    css: css`
        margin-top: 20px;
        display: flex;
        column-gap: 22px;
        ${xScreen("lte", "md")} {
            column-gap: 20px;
        }
        ${xScreen("lte", 767)} {
            flex-wrap: wrap;
            row-gap: 24px;
        }
    `,
};

containerStyles.leftSection = {
    css: css`
        flex-grow: 1;
        & > div:last-child > div:not(:last-child) {
            padding-bottom: 24px;
            margin-bottom: 24px;
            border-bottom: 1px solid ${color("common.border")};
        }
    `,
};
containerStyles.rightSection = {
    css: css`
        & > div {
            display: flex;
            flex-direction: column;
            position: sticky;
            top: 70px;
            ${xScreen("lte", "md")} {
                position: static;
            }
        }

        max-width: 317px;
        ${xScreen("lte", "md")} {
            max-width: 358px;
        }
        ${xScreen("lte", 767)} {
            max-width: 100%;
        }
    `,
};
